import axios from "./axios";

class InsuranceService {
  pospRegistration = async () => {
    try {
      const response = await axios.post("/insurance/posp_registration", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  pospLogin = async () => {
    try {
      const response = await axios.post("/insurance/get_login_url", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  policyReport = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page
  ) => {
    try {
      const response = await axios.post("/insurance/policy_report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new InsuranceService();
